module.exports = __webpack_public_path__ + "assets/img/39.302f1c4f.png";